
import Socket from './socket.js'
import Cast from './cast.js'

window.onload = async function() {

	window.app = {} // global object

	app.host = window.location.pathname.split('/')[1]

	const params = new URLSearchParams(window.location.search)
	const activate = params.get('activate')
	
	if(activate) { // https://share.rocketvox.com/xyz?activate=abc-123-def-456-ghi-789
		localStorage.setItem(app.host, activate)
		window.history.replaceState({}, document.title, window.location.pathname)
	}

	if(localStorage.getItem(app.host)) {
		// do host setup here
		app.key = localStorage.getItem(app.host) // cache
	}

	app.initialize = async () => {
		app.socket = new Socket()
		app.cast = new Cast()
	}

	app.initialize()
	
}


